export default class l_ali_player_progress {
  constructor(props) {
    this.ali_progress = document.createElement(`div`)
    this.ali_progress_animation = document.createElement(`div`)
    this.ali_progress_animation_circle = document.createElement(`div`)
    this.duration = props.duration
    this.lockKey = props.lockKey
  }
  createEl() {
    this.ali_progress.style.width = '100%'
    this.ali_progress.style.height = '4px'
    this.ali_progress.style.background = 'rgba(195,197,198,.5)'
    this.ali_progress.style.position = 'absolute'
    this.ali_progress.style.left = '0'
    this.ali_progress.style.bottom = '40px'
    this.ali_progress.style.zIndex = 200
    this.ali_progress.setAttribute('id', 'ali_progress')
    this.ali_progress.setAttribute('class', 'ali_progress')
    let prismControlbar = document.querySelector('.prism-controlbar')
    prismControlbar.appendChild(this.ali_progress)

    let ali_progress = document.querySelector('#ali_progress')
    let left = 0
    if (localStorage.getItem(this.lockKey)) {
      let seek = Number(localStorage.getItem(this.lockKey))
      left = ((seek / this.duration) * 100).toFixed(2)
    }
    this.ali_progress_animation.style.width = left ? `${left}%` : '0%'
    this.ali_progress_animation.style.height = '4px'
    this.ali_progress_animation.style.background = 'rgba(255,255,255,0.8)'
    this.ali_progress_animation.style.position = 'absolute'
    this.ali_progress_animation.style.left = '0'
    this.ali_progress_animation.style.top = '0'
    this.ali_progress_animation.setAttribute('class', 'ali_progress_animation')
    ali_progress.appendChild(this.ali_progress_animation)
    //  进度条上面的圆点
    this.ali_progress_animation_circle.style.width = '12px'
    this.ali_progress_animation_circle.style.height = '12px'
    this.ali_progress_animation_circle.style.borderRadius = '6px'
    this.ali_progress_animation_circle.style.position = 'absolute'
    this.ali_progress_animation_circle.style.background = 'rgb(255,255,255)'
    this.ali_progress_animation_circle.style.right = '-6px'
    this.ali_progress_animation_circle.style.top = '-4px'
    this.ali_progress_animation_circle.setAttribute(
      'class',
      'ali_progress_animation_circle'
    )
    this.ali_progress_animation.appendChild(this.ali_progress_animation_circle)
    //TODO 换成西瓜播放器的时候 拆开来
    this.eventClick(this.ali_progress)
  }
  timeupdate(el) {
    let left = ((el.getCurrentTime() / this.duration) * 100).toFixed(2)
    this.ali_progress_animation.style.width = `${left}%`
  }

  //事件
  eventClick(event) {
    if (window.location.pathname == '/learning/3') {
      event.style.cursor = 'pointer'
      event.onclick = (event) => {
        let leftWidth = event.offsetX
        let allWidth = document.getElementById('aliplayer').offsetWidth
        window.player.seek((leftWidth / allWidth) * this.duration)
      }
      document.addEventListener(
        'touchmove',
        (e) => {
          if (e.target.className == 'ali_progress_animation_circle') {
            let leftDistance =
              e.changedTouches[0].clientX -
              document.getElementById('aliplayer').getBoundingClientRect().left
            let allWidth = document.getElementById('aliplayer').offsetWidth
            window.player.seek((leftDistance / allWidth) * this.duration)
          }
        },
        true
      )
      document.addEventListener(
        'touchend',
        (e) => {
          if (e.target.className == 'ali_progress_animation_circle') {
            let leftDistance =
              e.changedTouches[0].clientX -
              document.getElementById('aliplayer').getBoundingClientRect().left
            let allWidth = document.getElementById('aliplayer').offsetWidth
            window.player.seek((leftDistance / allWidth) * this.duration)
          }
        },
        true
      )
    }
  }
}
